import React, { useCallback, useEffect } from 'react';
import { Box } from '@mui/material';
import { reusableStyles, tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';
import { useDispatch, useSelector } from 'react-redux';
import {
	createCanvasApiStageSelector,
	createCanvasAsync,
	createdCanvasIdSelector,
	resetCanvasSettings,
	resetCreatedCanvasStates,
} from 'core/store/reducers/canvasReducer/CanvasSlice';
import { ApiStage } from 'core/constants/enums/ApiStages.ts';
import { APP, STUDIO } from 'core/navigation/Routes';
import { ReactComponent as CanvasIcon } from 'core/assets/svg/canvas-page/canvas.svg';
import { setSelectedCharacter } from 'core/store/reducers/characterStudioReducer/CharaterStudioSlice';
import useCustomNavigate from 'core/hooks/useCustomNavigate';
import { ActionButton } from 'apps/canvas/canvas-list-page/components/DesktopAppToolbar';

export default function DesktopNewTab() {
	const navigate = useCustomNavigate();
	const dispatch = useDispatch();
	const createdCanvasId = useSelector(createdCanvasIdSelector);
	const createCanvasApiStage = useSelector(createCanvasApiStageSelector);

	const openNewCanvas = useCallback(() => {
		if (createdCanvasId !== null && window.electron) {
			navigate(`/${APP}/${STUDIO}/${createdCanvasId}`);
			dispatch(resetCreatedCanvasStates());
		}
	}, [createdCanvasId, dispatch, navigate]);

	useEffect(() => {
		if (createCanvasApiStage === ApiStage.SUCCESS) {
			openNewCanvas();
		}
	}, [createCanvasApiStage, openNewCanvas]);

	return (
		<Box
			id="desktop-new-tab"
			sx={[
				reusableStyles.flexColWithGap(16),
				{
					height: '100%',
					paddingTop: { xs: '40px', [tabletBreakpoint]: '80px' },
					alignItems: 'center',
				},
			]}
		>
			<ActionButton
				title={createCanvasApiStage === ApiStage.LOADING ? 'Creating...' : 'Create new Canvas'}
				icon={<CanvasIcon />}
				onClick={() => {
					dispatch(createCanvasAsync());
					dispatch(resetCanvasSettings());
					dispatch(setSelectedCharacter(null));
				}}
				disabled={createCanvasApiStage === ApiStage.LOADING}
			/>
		</Box>
	);
}
